import { NumberWithUnit } from "@foodpilot/foods";
import { useTranslation } from "react-i18next";

type LineScoreValueProps = {
    value: string | null;
    unit: string;
    size?: "micro" | "small";
};

export const LineScoreValue = (props: LineScoreValueProps) => {
    const { value, unit, size = "micro" } = props;
    const { t } = useTranslation();

    return (
        <NumberWithUnit
            value={value}
            unit={unit}
            size={size}
            emptyLabel={t("product.v2.score.unavailable", "Score unavailable")}
        />
    );
};
